import styled from '@emotion/styled'

export const BadgeLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`
